import { render, staticRenderFns } from "./costStatistics.vue?vue&type=template&id=992debf4&scoped=true"
import script from "./costStatistics.vue?vue&type=script&lang=js"
export * from "./costStatistics.vue?vue&type=script&lang=js"
import style0 from "./costStatistics.vue?vue&type=style&index=0&id=992debf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992debf4",
  null
  
)

export default component.exports